import { resizeSetDPI } from "store/features/resizeEditor/actions";
import { resizeEditorSelector } from "store/features/resizeEditor/selectors/resizeEditorSelector";
import { ResizeEditorState } from "store/features/resizeEditor/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { DPI } from "store/types/dpi";

export const useDPI = () => {
    const {
        resize: { dpi },
    } = useAppSelector(resizeEditorSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (option: DPI) => dispatch(resizeSetDPI(option));

    return {
        dpi,
        handleChange,
    };
};

const equalityFn = (left: ResizeEditorState, right: ResizeEditorState) => {
    if (left.resize.dpi !== right.resize.dpi) return false;

    return true;
};
